import React from 'react';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../api/axios';
import emailIcon from '../images/icon/email-icon.png'
import googleIcon from '../images/icon/google-icon.webp'
import '../gral-stylesheets/login.scss';



const Login = (props) => {

  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailChange, setEmailChange] = useState(false);
  const [passwordChange, setPasswordChange] = useState(false);

  useEffect(() => {
    props.joinState || props.loginState || props.passwordResetState || props.successState
      ? document.body.style.overflow = 'hidden'
      : document.body.style.overflow = 'unset'
  }, [props.joinState, props.loginState, props.passwordResetState, props.successState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let loginURL = '/login';
    let formData = { email, password };
    let axiosConfig = {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }

    await axios
      .post(
        loginURL,
        formData,
        axiosConfig
      )
      .then((response) => {
        if (response.data.accessToken) {
          let id = response.data.user.id;
          const token = response.data.accessToken;
          localStorage.setItem('id', id);
          localStorage.setItem('email', email);
          localStorage.setItem('password', password);
          localStorage.setItem('token', token);
          setAuth(email, token);
          setEmail('');
          setPassword('');
          if (response.data.user.profileImage) {
            let profileImage = response.data.user.profileImage;
            localStorage.setItem('profileImage', profileImage);
          }
          if (response.data.user.personalInfo) {
            let personalInfo = response.data.user.personalInfo;
            localStorage.setItem('personalInfo', JSON.stringify(personalInfo));
          }
          navigate('/authenticated');
          props.loginClose();
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  if (!props.loginState) {
    return null
  }
  return (
    <div 
      className='modal-container-overlay'
      onClick={props.loginClose}
      >
      <div 
        className='login-box'
        onClick={ (e) => e.stopPropagation() }
        >
        <div className='login-header'>
          <div className='login-title'>
            <h3>Login</h3>
          </div>
          <h4>Wellcome back, <br /> login to your account</h4>
        </div>
        <form
          className='login-form'
          onSubmit={handleSubmit}
        >
          <div className='input-container'>
            <label
              className='login-input-label'
              htmlFor='email'
            >
            <h5
              className={
                emailChange ?
                  'input-label up' : 
                    email !== '' ? 
                    'input-label up' : 'input-label'
              }
            >
              Email
            </h5>
            </label>
            <input
              type='email'
              id='email'
              name='email'
              className='input-login'
              autoCapitalize='none'
              autoComplete='email'
              maxLength='150'
              required
              onFocus={() => { setEmailChange(true) }}
              onBlur={(e) => { setEmailChange(false) }}
              onChange={(e) => { setEmail(e.target.value) }} 
            />
          </div>
          <div className='input-container'>
            <label
              className='login-input-label'
              htmlFor='passwordIngress'
            >
            <h5 
              className={
                passwordChange ?
                  'input-label up' : 
                    password !== '' ? 
                    'input-label up' : 'input-label'
              }
            >
              Password
            </h5>
            </label>
            <input
              type='password'
              id='passwordIngress'
              name='passwordIngress'
              className='input-login'
              required
              onFocus={() => { setPasswordChange(true) }}
              onBlur={(e) => { setPasswordChange(false) }}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className='input-container'>
            <div className='login-forgot-password'>
              <h5 onClick={props.toPasswordReset}>Forgot password?</h5>
            </div>
          </div>
          <div className='input-container'>
            <button
              type='submit'
              className='login-button'
            >
              <h4>Login</h4>
            </button>
          </div>
          <div className='input-container'>
            <button
              type='submit'
              className='login-button-2'
            >
              <img className='image-icon' src={emailIcon} alt='icon-email' />
              <h4>Continue with Email</h4>
            </button>
          </div>
          <div className='input-container'>
            <button
              type='submit'
              className='login-button-2'
            >
              <img className='image-icon' src={googleIcon} alt='icon-google' />
              <h4>Continue with Google</h4>
            </button>
          </div>
        </form>
        <div className='login-register'>
          <h3>Don't have an DearHR account yet?</h3>
          <p onClick={props.toJoin}>
            Register here
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login;